module.exports = __webpack_public_path__ + "img/ScanCheck.d2c2a4fb.svg";